import { render, staticRenderFns } from "./TheErrorMessage.vue?vue&type=template&id=7bd907fa"
import script from "./TheErrorMessage.vue?vue&type=script&lang=js"
export * from "./TheErrorMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports